export default "__VITE_ASSET__pgQhffrD__"